import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CustomerAddress } from '../../customers/customer.interface';
import { AddressService } from './address.service';

const service = new AddressService();

export interface AddressState {}

const AddressStore: Module<AddressState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async createAddress(context, payload: { companyId: number; address: CustomerAddress }) {
         const response = await service.postAddress(payload.companyId, payload.address);
         return response.data;
      },
      async putAddress(
         context,
         {
            companyId,
            addressId,
            address,
            is_paginated,
         }: { companyId: number; addressId: number; address: CustomerAddress; is_paginated: boolean },
      ) {
         const response = await service.putAddress(companyId, addressId, address, is_paginated);
         return response.data;
      },
      async postAddress(
         context,
         { companyId, address, is_paginated }: { companyId: number; address: CustomerAddress; is_paginated: boolean },
      ) {
         const response = await service.postAddress(companyId, address, is_paginated);
         return response.data;
      },
      async deleteAddress(
         context,
         { companyId, addressId, is_paginated }: { companyId: number; addressId: number; is_paginated: boolean },
      ) {
         const response = await service.deleteAddress(companyId, addressId, is_paginated);
         return response.data;
      },
      async call(context, { companyId, addressId, hitId }: { companyId: number; addressId: number; hitId?: number }) {
         const response = await service.call(companyId, addressId, hitId);
         return response.data;
      },
      async inviteToVideoRoom(
         context,
         { customerId, videocallRoomId, addressId }: { customerId: number; videocallRoomId: number; addressId: number },
      ) {
         const response = await service.inviteToVideoRoom(customerId, videocallRoomId, addressId);
         return response.data;
      },
      async searchAddress(context, payload: { companyId: number; search: string }) {
         const response = await service.searchAddress(payload.companyId, payload.search);
         return response.data;
      },
   },
};

export default AddressStore;
